import { SITE } from '@/app/constants';
import { safeStorage } from '@/app/utils/client';

// The China site added a required voiceprint consent, so users who only agreed to v1 must consent again.
const LIVE_CALL_CONSENT_STORAGE_KEY = SITE === 'china' ? 'live_video_call_consent_v2' : 'live_video_call_consent_v1';
const LIVE_FACE_CONSENT_STORAGE_KEY = 'live_face_consent_v1';

export interface LiveCallConsentResult {
  isFaceConsentAgreed: boolean;
}

function getLiveCallConsentStorageKey(userId: string): string {
  return `${LIVE_CALL_CONSENT_STORAGE_KEY}_${userId}`;
}

function getLiveFaceConsentStorageKey(userId: string): string {
  return `${LIVE_FACE_CONSENT_STORAGE_KEY}_${userId}`;
}

export function hasLiveCallConsent(userId: string | undefined): boolean {
  if (!userId) {
    return false;
  }

  return safeStorage.getItem(getLiveCallConsentStorageKey(userId)) === 'true';
}

export function saveLiveCallConsent(userId: string): void {
  safeStorage.setItem(getLiveCallConsentStorageKey(userId), 'true');
}

/** Face consent is only required on the China site. */
export function hasLiveFaceConsent(userId: string | undefined): boolean {
  if (SITE !== 'china') {
    return true;
  }
  if (!userId) {
    return false;
  }

  return safeStorage.getItem(getLiveFaceConsentStorageKey(userId)) === 'true';
}

export function saveLiveFaceConsent(userId: string): void {
  safeStorage.setItem(getLiveFaceConsentStorageKey(userId), 'true');
}

export function saveLiveCallConsentResult(userId: string, { isFaceConsentAgreed }: LiveCallConsentResult): void {
  saveLiveCallConsent(userId);
  if (isFaceConsentAgreed) {
    saveLiveFaceConsent(userId);
  }
}
